module.exports = __webpack_public_path__ + "img/nscontact.12a3a8e9.jpg";